/**
 * Import custom styles.
 */
import { COLORS, focusStyles } from '../styles';

/**
 * Import third-party libraries.
 */
import styled, { css } from 'styled-components';
import { ComponentLStyling, ComponentMStyling, ComponentSStyling, ComponentTextStyle } from '../styles/typography';

export const StyledSwitch = styled.div<{ selected: boolean | undefined }>`
  display: flex;
  flex-direction: row;
  width: max-content;
  min-height: 48px;
  min-width: 48px;
  align-items: center;
  cursor: pointer;
  &.small {
    ${ComponentSStyling(ComponentTextStyle.Regular, COLORS.black)}
  }

  &.medium {
    ${ComponentMStyling(ComponentTextStyle.Regular, COLORS.black)}
  }

  &.large {
    ${ComponentLStyling(ComponentTextStyle.Regular, COLORS.black)}
  }
  &.disabled {
    color: ${COLORS.neutral_300};

    .label {
      cursor: not-allowed;
    }
  }
  .label {
    cursor: inherit;
    margin-left: 8px;
  }

  &:not(.disabled):active label:first-of-type span {
    &:before {
      background-color: ${COLORS.primary_100};
    }
  }

  &.disabled[aria-pressed='true'] label:first-of-type span {
    background-color: ${COLORS.neutral_300} !important;
    cursor: not-allowed;

    &:before {
      background-color: ${COLORS.neutral_200} !important;
      cursor: not-allowed;
    }
  }

  &[aria-pressed='true']:hover span {
    &.semantic {
      background-color: ${COLORS.correct_500};
    }

    &:before {
      background-color: ${COLORS.primary_20};
    }
  }

  &[aria-pressed='true'] label:first-of-type span {
    background-color: ${COLORS.primary_500};

    &.semantic {
      background-color: ${COLORS.correct_500};
    }

    &:before {
      -webkit-transform: translateX(20px);
      -ms-transform: translateX(20px);
      transform: translateX(20px);
    }
  }

  &.disabled[aria-pressed='false'] label:first-of-type span {
    background-color: ${COLORS.neutral_300} !important;
    cursor: not-allowed;

    &:before {
      background-color: ${COLORS.neutral_100} !important;
      cursor: not-allowed;
    }
  }

  &[aria-pressed='false']:hover label:first-of-type span {
    &.semantic {
      background-color: ${COLORS.critical_500};
    }

    &:before {
      background-color: ${COLORS.primary_20};
    }
  }

  &:not(.disabled).focus-visible {
    ${focusStyles}
  }

  &:not(.disabled) label:first-of-type {
    cursor: inherit;
  }
`;

export const ToggleSwitchContainer = styled.label`
  position: relative;
  align-items: center;
  display: inline-flex;
  height: 28px;
  width: auto;
  padding: 10px 6px;
`;

export const ToggleSwitch = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 36px;
  height: 16px;
  background-color: ${COLORS.neutral_500};
  border-radius: 100px;

  &.semantic {
    background-color: ${COLORS.critical_500};
  }

  &:before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    left: 2px;
    top: calc(50% - 6px);
    background-color: ${COLORS.white};
    -webkit-transition: background-color 0.1s, transform 0.1s;
    transition: 0.1s;
    transition-timing-function: ease-in-out;
    border-radius: 50%;
  }
`;
